import { z } from 'zod';

// Site master data and the commissioning wizard (ADR-0017). Kept on the gateway: it belongs to
// the site and is printed with the commissioning protocol.

/** §14a grid fee module (documentation only, chosen by the customer with the grid operator) */
export const Module14a = z.union([z.literal(1), z.literal(2), z.literal(3)]);
export type Module14a = z.infer<typeof Module14a>;

const text = (max: number) => z.string().trim().max(max).default('');

export const SiteProfile = z.object({
  customerName: text(120),
  street: text(120),
  zip: z
    .string()
    .trim()
    .regex(/^(\d{5})?$/, 'Postleitzahl mit 5 Ziffern')
    .default(''),
  city: text(80),
  gridOperator: text(120),
  meterNumber: text(40),
  /** yyyy-mm-dd */
  commissionedAt: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
  installerName: text(120),
  module14a: Module14a.nullable().default(null),
  updatedAt: z.string().optional(),
});
export type SiteProfile = z.infer<typeof SiteProfile>;

export const WIZARD_STEPS = [
  'network',
  'profile',
  'grid',
  'devices',
  'tariffs',
  'customerView',
  'test',
  'protocol',
] as const;
export const WizardStep = z.enum(WIZARD_STEPS);
export type WizardStep = z.infer<typeof WizardStep>;

export const WizardProgress = z.object({
  done: z.array(WizardStep).default([]),
  current: WizardStep.default('network'),
});
export type WizardProgress = z.infer<typeof WizardProgress>;
